
import minreviewCount from './minreviewCount.json'
import maxreviewCount from './maxreviewCount.json'
import minrating from './minrating.json'
import maxrating from './maxrating.json'
import budgetMinList from './budgetMinList.json';
import budgetMaxList from './budgetMaxList.json';
import mindays from './mindays.json';
import maxdays from './maxdays.json';

export const FILTER_TYPE_MIN_MAX = 'MinMaxSelect';
export const photographerPageFilters = [
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "budget",
        "displayName": "Budget",
        "queryParamName": "budget",
        "_id": "5c1241e9caa9a513e691c6f3",
        "params": [],
        "minParams": budgetMinList,
        "maxParams": budgetMaxList,
        "minQueryParamName": "min_price",
        "maxQueryParamName": "max_price"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "reviews",
        "displayName": "Review Count",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f4",
        "params": [],
        "minParams": minreviewCount,
        "maxParams": maxreviewCount,
        "minQueryParamName": "min_reviews",
        "maxQueryParamName": "max_reviews"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "rating",
        "displayName": "Rating",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f5",
        "params": [],
        "minParams": minrating,
        "maxParams": maxrating,
        "minQueryParamName": "min_rating",
        "maxQueryParamName": "max_rating"
    },
    {
        "filterType": FILTER_TYPE_MIN_MAX,
        "keyName": "days",
        "displayName": "Number of Days",
        "queryParamName": "",
        "_id": "5c1241e9caa9a513e691c6f6",
        "params": [],
        "minParams": mindays,
        "maxParams":  maxdays,
        "minQueryParamName": "min_days",
        "maxQueryParamName": "max_days"
    }
]
